import { MeasureController } from "../../MeasureController";
import { JudgmentResult, JudgmentResultType, JudgmentResultEnum } from "../../types.client";
import { parseSpeedValue } from "../../utils/parseValue.utils";
import { LinkSpeedMeasure } from "../../../models/schemas/measures/communication.schema";
import { LINK_SPEED_THRESHOLDS } from "../../constants/judgmentCriteria";

/**
 * 링크 동작 속도 컨트롤러
 * 판정 기준: 측정속도 >= 설계속도 * LINK_SPEED_THRESHOLDS.min (80% 이상)
 */
export class LinkSpeedController extends MeasureController<LinkSpeedMeasure> {
  protected getDefaultData(): LinkSpeedMeasure {
    return {
      designSpeed: "",
      measuredSpeed: "",
      unit: "Mbps",
      result: null,
      discussion: "",
      remark: "",
      photo: { checkUrl: "", resultUrl: "" },
    };
  }

  protected judge(): JudgmentResult {
    const { designSpeed, measuredSpeed } = this.data;

    // 데이터 미입력 시
    if (!designSpeed || !measuredSpeed) {
      return {
        result: JudgmentResultEnum.NA,
        discussion: this.generateDiscussion(JudgmentResultEnum.NA),
      };
    }

    // parseSpeedValue 사용: "100Mbps" → 100, "1Gbps" → 1000
    const designMbps = parseSpeedValue(designSpeed);
    const measuredMbps = parseSpeedValue(measuredSpeed);

    if (designMbps === null || measuredMbps === null) {
      return {
        result: JudgmentResultEnum.NA,
        discussion: this.generateDiscussion(JudgmentResultEnum.NA),
      };
    }

    // 판정: 측정속도 >= 설계속도 * LINK_SPEED_THRESHOLDS.min (80%)
    const threshold = designMbps * LINK_SPEED_THRESHOLDS.min;
    const result: JudgmentResultType =
      measuredMbps >= threshold ? JudgmentResultEnum.GOOD : JudgmentResultEnum.BAD;

    return {
      result,
      discussion: this.generateDiscussion(result),
    };
  }

  protected generateDiscussion(result: JudgmentResultType): string {
    if (result === JudgmentResultEnum.NA) {
      return "데이터 미입력";
    }
    if (result === JudgmentResultEnum.GOOD) {
      return "링크 속도가 설계값의 80% 이상으로 정상 작동";
    }
    return "링크 속도가 설계값 대비 낮음. 점검 필요";
  }
}
